import { OPTUM_FRONTIER_THERAPIES } from "shared/src/data/provider-names";
import { useProviderName } from "./use-provider-name";

export function useAllowSucraid(): boolean {
  const providerName = useProviderName();
  return providerName?.includes(OPTUM_FRONTIER_THERAPIES) ?? false;
}
